import { useMutation, useQueryClient } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import { putUserNotificationsDismiss } from "Notifications/Api/notificationApi";
import { NOTIFICATIONS_QUERY_KEYS } from "Notifications/Api/Queries/queryKeys";

export function useDismissMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((userNotificationID: string) =>
      putUserNotificationsDismiss(userNotificationID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: NOTIFICATIONS_QUERY_KEYS.all,
      });
    },
  });
}
